<sbe-app-shell-root
  [infraError]="auth.infraError()"
  (retry)="retry()"
  [homeRoute]="homeRoute()"
  [navItems]="navItems()"
  [shellBare]="shellBare()"
  [showBootLoading]="showBootLoading()"
  [loggedIn]="auth.isAuthenticated()"
  [containerMaxWidthClass]="containerClass()"
>
  <a shellSidenavHeader class="conduct-school" [routerLink]="homeRoute()">
    <img src="/images/conduct-school.png" alt="" width="32" height="32" />
    @if (activeOrg.school(); as school) {
    <span>{{ school.name }}</span>
    } @else if (activeOrg.loading() || !auth.ready()) {
    <!-- Blank while the session restores or the name loads, so the fallback text does not flash. -->
    } @else if (activeOrg.orgId()) {
    <span i18n="@@conductSchoolEntered">학교종이에서 연 학교</span>
    } @else {
    <span i18n="@@conductSchoolEmpty">연결된 학교 없음</span>
    }
  </a>
  @if (auth.isAuthenticated()) {
  <spinoff-profile-menu shellToolbarEnd (logoutRequested)="logout()" />
  }
</sbe-app-shell-root>
